import React, { useState } from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import {
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	FormContainer,
	Wrapper,
	FormContent
} from '../../ui/form'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import { addFlashMessage, hideLoader, login as loginAction, showLoader } from '../../../actions'
import { updateUserName } from '../../../api'
import Feedback from '../../feedback'

const ChangeUserName = ({ auth, dispatch }) => {
	const history = useHistory()
	const [name, setName] = useState(auth?.nombre || '')
	const [lastname, setLastname] = useState(auth?.apellido || '')
	const [loading, setLoading] = useState(false)
	const [isChanged, setIsChanged] = useState({changed: false, error: false})

	const handleSubmit = async e => {
		e.preventDefault()

		setLoading(true)
		dispatch(showLoader())

		const params = { id: auth?.idUsuario, nombre: name, apellido: lastname }
		const [err] = await to(updateUserName(params))

		if (err) {
			setIsChanged({changed: true, error: true})
			setLoading(false)
			dispatch(hideLoader())
			return
		}

		dispatch(
			loginAction({
				...auth,
				nombre: name,
				apellido: lastname
			})
		)

		setLoading(false)
		setIsChanged({changed: true, error: false})
		dispatch(hideLoader())
	}

	const handleCancel = () => {
		history.push('/inicio/mis-datos')
	}

	return (
		isChanged.changed ? 
		<Feedback
			title={!isChanged.error ? "Actualizamos tus datos" : "Hubo un error al actualizar tus datos"}
			bodyText={!isChanged.error ? "Actualizamos tus datos con éxito" : "Por favor volvé a intentarlo más tarde"}
			buttonLabel="Volver al inicio"
			onClickButton={handleCancel}
			isError={isChanged.error}
		/>
		: (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				<FormContainer justifyMobile="center" align="start" margin="0 0">
					<FormHeader align="start">
						<FormTitle align={'start'}>Cambiar nombre y apellido</FormTitle>
					</FormHeader>
						<FormContent>
						<InputsContainer>
							<Input fullWidth value={name} label={'Nombre'} onChange={e => setName(e.target.value)} />
							<Input fullWidth value={lastname} label={'Apellido'} onChange={e => setLastname(e.target.value)} />
						</InputsContainer>
						<ButtonsContainer>
							<Button label={'Guardar cambios'} $variant="primary" size="mobile" type="submit" disabled={loading} />
							<LinkButton type="button" onClick={handleCancel}>Cancelar</LinkButton>
						</ButtonsContainer>
					</FormContent>
				</FormContainer>
			</form>
		</Wrapper>
	))
}
const mapStateToProps = ({ auth }) => ({ auth })

export default connect(mapStateToProps)(ChangeUserName)
